/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestEmailConfirmation.defs'
export { main as default } from './requestEmailConfirmation.defs'
